import deepadminApi from '@/api/deepadmin/deepadmin';
import type { AxiosRequestConfig } from 'axios';
//TODO @daniel.henkiel missing api definition
export const obtainMobileIdStatus = (
  payload: object,
  config?: AxiosRequestConfig
) => deepadminApi.post('mobileid/check', payload, config);
